/* Mewpouch - Shopify cart wiring */
(function(){
  var V = window.MP_VARIANTS || [];
  var ALIAS = { '2XL':'XXL', 'XXL':'2XL' };
  var RRP = 9990;          /* per-unit anchor, cents */
  var FREE = (typeof FREE_SHIP !== 'undefined' ? FREE_SHIP : 60) * 100;

  var GIFTS = [
    { n:'Catnip Kicker Fish',      e:'🐟' },
    { n:'Feather Teaser Wand',     e:'🎣' },
    { n:'Silicone Grooming Glove', e:'🧤' },
    { n:'Crinkle Ball 4-Pack',     e:'🎾' }
  ];
  function giftCount(q){ return q >= 3 ? 4 : (q >= 2 ? 2 : 0); }
  function giftValue(q){ return q >= 3 ? 7800 : (q >= 2 ? 4000 : 0); }

  function findVariant(color, size){
    var want = [size, ALIAS[size]].filter(Boolean);
    for (var i=0;i<V.length;i++){
      if (V[i].option1 === color && want.indexOf(V[i].option2) !== -1) return V[i];
    }
    return null;
  }
  window.findVariant = findVariant;

  function c2m(c){ return '$' + (c/100).toFixed(2); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(m){
    return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' })[m]; }); }

  /* supplier ships-from option must never reach the customer */
  function cleanVariant(t){
    if (!t) return '';
    return t.split('/').map(function(p){ return p.trim(); })
      .filter(function(p){ return p && !/china|mainland|ships?\s*from/i.test(p); })
      .join(' · ');
  }

  function post(url, body){
    return fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(body) }).then(function(r){ return r.json(); });
  }
  function setLine(line, qty){ return post('/cart/change.js', { line: line, quantity: qty }).then(paintCart); }

  function el(tag, cls, html){
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    if (html != null) d.innerHTML = html;
    return d;
  }

  function ensureFooterExtras(){
    var df = document.querySelector('.df');
    if (!df || df.querySelector('.dtrust')) return;
    var fine = df.querySelector('.dfine');
    var trust = el('div','dtrust',
      '<span>🔒 Secure<br>checkout</span>' +
      '<span>↩️ 30-day<br>returns</span>' +
      '<span>🚚 Tracked<br>delivery</span>');
    var pay = el('div','dpay','<i>VISA</i><i>MC</i><i>AMEX</i><i>PayPal</i><i>Shop Pay</i>');
    df.insertBefore(trust, fine || null);
    df.insertBefore(pay, fine || null);
  }

  function paintCart(cart){
    var b = document.getElementById('dBody');
    if (!b) return cart;
    b.innerHTML = '';

    var units = 0;
    cart.items.forEach(function(it){ units += it.quantity; });

    /* ---- head count ---- */
    var h3 = document.querySelector('.dh h3');
    if (h3) h3.innerHTML = 'Your cart' + (units ? ' <span class="cnt">' + units + '</span>' : '');

    if (!cart.items.length){
      b.appendChild(el('div','dempty',
        '🛒<br>Your cart is empty.<br><span style="font-size:12px;opacity:.8">Your cat is waiting.</span>'));
    } else {
      /* ---- gifts ---- */
      var gc = giftCount(units);
      if (gc){
        var rows = '';
        for (var g=0; g<gc; g++){
          rows += '<div>' + GIFTS[g].e + ' ' + esc(GIFTS[g].n) +
                  '<span class="f">FREE</span></div>';
        }
        b.appendChild(el('div','giftbox',
          '<div class="gh">🎁 ' + gc + ' free gift' + (gc>1?'s':'') + ' unlocked' +
          '<span class="val"><s>' + c2m(giftValue(units)) + '</s>FREE</span></div>' +
          '<div class="giftlist">' + rows + '</div>'));
      }

      /* ---- line items ---- */
      cart.items.forEach(function(it, i){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var d = el('div','li');
        d.innerHTML =
          '<img src="' + esc(img) + '" alt="" loading="lazy">' +
          '<div class="lx">' +
            '<div class="lt">' + esc(it.product_title) + '</div>' +
            '<div class="lv">' + esc(cleanVariant(it.variant_title)) + '</div>' +
            '<div class="qty" role="group" aria-label="Quantity">' +
              '<button type="button" aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="lp">' + c2m(it.line_price) +
              (it.quantity * RRP > it.line_price
                ? ' <s>' + c2m(it.quantity * RRP) + '</s>' : '') +
            '</div>' +
          '</div>';
        var qb = d.querySelectorAll('.qty button');
        qb[0].onclick = function(){ setLine(i+1, it.quantity - 1); };
        qb[1].onclick = function(){ setLine(i+1, it.quantity + 1); };
        var rm = el('button','rm','Remove');
        rm.onclick = function(){ setLine(i+1, 0); };
        d.appendChild(rm);
        b.appendChild(d);
      });

      /* ---- upsell to the next gift tier ---- */
      if (units < 3){
        var need = units < 2 ? 2 - units : 1;
        var nextG = giftCount(units + need);
        var box = el('div','upsell',
          '<div class="ut">🔥 Add ' + need + ' more and unlock <b>' +
            nextG + ' free gifts</b> — worth ' + c2m(giftValue(units + need)) +
          '</div>');
        var btn = el('button', null, 'ADD ' + need + ' MORE');
        btn.onclick = function(){
          var first = cart.items[0];
          if (!first) return;
          btn.disabled = true; btn.textContent = 'Adding…';
          setLine(1, first.quantity + need);
        };
        box.appendChild(btn);
        b.appendChild(box);
      }
    }

    /* ---- totals ---- */
    var sub = document.getElementById('dSub');
    if (sub) sub.textContent = c2m(cart.total_price);
    var cc = document.getElementById('cartCount');
    if (cc) cc.textContent = cart.item_count;

    var saved = (units * RRP) - cart.total_price;
    var sv = document.getElementById('dSave');
    if (sv){
      var amt = document.getElementById('dSaveAmt');
      if (saved > 0 && units){
        sv.style.display = '';
        sv.firstChild && (sv.firstChild.textContent = '🎉 You save');
        if (amt) amt.textContent = '−' + c2m(saved);
      } else {
        sv.style.display = 'none';
      }
    }

    /* ---- free shipping meter ---- */
    var fill = document.getElementById('sFill');
    var txt  = document.getElementById('shipTxt');
    if (fill) fill.style.width = Math.min(100, cart.total_price / FREE * 100) + '%';
    if (txt){
      if (cart.total_price >= FREE){
        txt.className = 't ok';
        txt.innerHTML = '🎉 <b>Free shipping unlocked</b>';
      } else {
        txt.className = 't';
        txt.innerHTML = '🚚 Add <b>' + c2m(FREE - cart.total_price) +
                        '</b> for <b>FREE</b> shipping';
      }
    }

    ensureFooterExtras();
    return cart;
  }

  function refresh(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); }).then(paintCart);
  }

  function addLines(after){
    var v = findVariant(state.color, state.size);
    if (!v){ toast('That colour and size is not available'); return; }
    if (v.available === false){ toast(state.color + ' / ' + state.size + ' is sold out'); return; }
    post('/cart/add.js', { items: [{ id: v.id, quantity: state.tier,
                                     properties: { Bundle: state.tier + '-pack' } }] })
      .then(refresh)
      .then(function(){ if (after) after(); })
      .catch(function(){ toast('Could not add to cart'); });
  }

  window.addToCart = function(){
    addLines(function(){ openCart();
      toast(state.tier + ' item' + (state.tier>1?'s':'') + ' added'); });
  };
  window.buyNow = function(){ addLines(function(){ location.href = '/checkout'; }); };

  var chk = document.querySelector('.chk-btn');
  if (chk){
    chk.innerHTML = '🔒 SECURE CHECKOUT';
    chk.onclick = function(){ location.href = '/checkout'; };
  }

  var base = window.render;
  window.render = function(){
    base();
    var v = findVariant(state.color, state.size);
    var btn = document.querySelector('.cta-1');
    if (!btn) return;
    if (v && v.available === false){ btn.style.opacity = '.5'; btn.dataset.sold = '1'; }
    else { btn.style.opacity = ''; delete btn.dataset.sold; }
  };

  refresh();
  if (typeof render === 'function') render();
})();
